var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBurgerMenuIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.09091 5.5H22.9091C23.5116 5.5 24 4.94036 24 4.25C24 3.55964 23.5116 3 22.9091 3H1.09091C0.488419 3 1.90735e-06 3.55964 1.90735e-06 4.25C1.90735e-06 4.94036 0.488419 5.5 1.09091 5.5Z",
    fill: "#EBEBF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9091 11H1.09091C0.488419 11 1.90735e-06 11.5596 1.90735e-06 12.25C1.90735e-06 12.9404 0.488419 13.5 1.09091 13.5H22.9091C23.5116 13.5 24 12.9404 24 12.25C24 11.5596 23.5116 11 22.9091 11Z",
    fill: "#EBEBF9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9091 19H1.09091C0.488419 19 1.90735e-06 19.5596 1.90735e-06 20.25C1.90735e-06 20.9404 0.488419 21.5 1.09091 21.5H22.9091C23.5116 21.5 24 20.9404 24 20.25C24 19.5596 23.5116 19 22.9091 19Z",
    fill: "#EBEBF9"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBurgerMenuIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/burgerMenuIcon.028cc17fdda9420bf144d8d89f803fb7.svg";